// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-templates-blog-template-tsx": () => import("./../src/templates/blog.template.tsx" /* webpackChunkName: "component---src-templates-blog-template-tsx" */),
  "component---src-templates-single-template-tsx": () => import("./../src/templates/single.template.tsx" /* webpackChunkName: "component---src-templates-single-template-tsx" */),
  "component---src-pages-404-tsx": () => import("./../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-newsletter-tsx": () => import("./../src/pages/newsletter.tsx" /* webpackChunkName: "component---src-pages-newsletter-tsx" */)
}

